const Keycloak = require('keycloak-js');
const axios = require('axios');
import urlConf from '../../../config/urls.conf.js';

function BespinSso(platApiUrl) {
    console.log('BespinSso()', platApiUrl);
    this.platApiUrl = platApiUrl;
    var that = this;

    this.init = function(platApiUrl) {
        return new Promise(function (resolve, reject) {
            try {
                // 환경별 gateway URL을 직접 호출
                const gatewayUrl = urlConf.apiGwUrl + '/platform/v1/plat/sites/keycloak-json';

                axios.get(gatewayUrl, {
                    params: {
                        domain: window.location.hostname,
                        svcType: 'frontend'
                    }
                }).then(function(response) {
                    // response.data가 undefined인 경우를 처리
                    if (!response || !response.data || !response.data.result) {
                        console.error('Invalid API response:', response);
                        reject(new Error('Invalid API response structure'));
                        return;
                    }

                    const { keycloakJson } = response.data.result;
                    if (!keycloakJson) {
                        console.error('keycloakJson not found in response:', response.data);
                        reject(new Error('keycloakJson not found in response'));
                        return;
                    }

                    const keycloakConfig = JSON.parse(keycloakJson);
                    // 백엔드에서 제공하는 keycloakJson 설정을 그대로 사용
                    that.keycloak = new Keycloak(keycloakConfig);

                    that.keycloak.init({
                        onLoad: 'check-sso',
                        checkLoginIframe: true,
                        silentCheckSsoRedirectUri: window.location.origin + '/static/silent-check-sso.html'
                    });

                    resolve(that.keycloak);
                }).catch(function(error) {
                    console.error('Error calling keycloak-json API:', error);
                    reject(error);
                });
            } catch (e) {
                console.error('Unexpected error in init:', e);
                reject(e);
            }
        });
    };

    this.getKeycloak = function() {
        return this.keycloak;
    };

    this.getSessionCount = function() {
        return new Promise(function (resolve, reject) {
            try {
                // const { authServerUrl, realm, clientId, token } = that.keycloak;
                var authServerUrl = that.keycloak.authServerUrl;
                var realm = that.keycloak.realm;
                var clientId = that.keycloak.clientId;
                var token = that.keycloak.token;

                // 환경별 SSO URL 사용 (CORS 문제 해결)
                var apiUrl = authServerUrl + '/realms/' + realm + '/api/users/me/session-count';

                axios.get(apiUrl, {
                    headers: {
                        Authorization: 'Bearer ' + token
                    },
                    params: {
                        clientId: clientId
                    }
                }).then(function (response) {
                    resolve(response.data.count);
                });
            } catch (e) {
                reject(e);
            }
        });
    };
    this.logoutAllSession = function(withoutCurrent) {
        return new Promise(function (resolve, reject) {
            try {
                // const { authServerUrl, realm, clientId, token } = that.keycloak;
                var authServerUrl = that.keycloak.authServerUrl;
                var realm = that.keycloak.realm;
                var clientId = that.keycloak.clientId;
                var token = that.keycloak.token;

                // 환경별 SSO URL 사용 (CORS 문제 해결)
                var apiUrl = authServerUrl + '/realms/' + realm + '/api/users/me/logout-allsession';

                axios.get(apiUrl, {
                    headers: {
                        Authorization: 'Bearer ' + token
                    },
                    params: {
                        clientId: clientId,
                        withoutCurrent: withoutCurrent
                    }
                }).then(function () {
                    resolve();
                });
            } catch (e) {
                reject(e);
            }
        });
    };

}

export default BespinSso;



// WEBPACK FOOTER //
// ./src/services/sso/bespinsso.js